import { TooltipProvider } from "@iyk/ui"
import { NuqsAdapter } from "nuqs/adapters/react-router/v7"
import { ToastProvider } from "./Toast.tsx"

/**
 * This hosts all necessary providers for Music UI:
 *
 * - "isolate" className is used for base-ui to unsure portalled components are always on top of other components
 *   (see: https://base-ui.com/react/overview/quick-start#set-up-portals)
 * - ToastProvider is used to display toast notifications
 * - NuqsAdapter is used for `nuqs` library
 */
export const MusicProviders = ({ children }: { children: React.ReactNode }) => {
  return (
    <NuqsAdapter>
      <TooltipProvider>
        <ToastProvider>
          <div className="isolate">{children}</div>
        </ToastProvider>
      </TooltipProvider>
    </NuqsAdapter>
  )
}
